import { staticColors } from '@common/utils/colors';

export const PUSH_ACTION_COLORS = {
  signature: staticColors[0],
  banner: staticColors[1],
  appendhtml: staticColors[2],
  findandreplace: staticColors[3],
  bizcard: staticColors[4]
};

export const PUSH_ACTION_MODE = {
  signature: 'label.SIGNATURE',
  banner: 'label.BANNER',
  appendhtml: 'label.APPEND_HTML',
  findandreplace: 'label.FIND_AND_REPLACE'
};

export const PUSH_ACTION_TYPES = {
  pushbizcard: 'label.BUSINESS_CARD',
  pushemail: 'label.EMAIL',
  pushfrontapp: 'label.FRONTAPP',
  pushgoogle: 'label.GOOGLE',
  pusho365: 'label.MICROSOFT_365',
  pushoutreach: 'label.OUTREACH',
  pushsalesforce: 'label.SALESFORCE',
  editfrontapp: 'label.EDIT_FRONTAPP',
  editgoogle: 'label.EDIT_GOOGLE',
  editoutreach: 'label.EDIT_OUTREACH'
};

export const AUTO_PUSH_TYPES = {
  ptp: 'PTP',
  visual: 'label.VISUAL'
};